import type { AssignConditionType } from "../@types/services/AssignConditionType";
import { api } from "./api";

const API_BASE_URL = "/vbuyer/api/v2/assign_conditions";

interface ManageUserAssignConditionResponse {
  assign_conditions: AssignConditionType[];
  full_name_with_login: string;
  full_name: string;
  has_photo?: boolean;
  id: number;
  login: string;
  photo_url?: string | null;
}

export const fetchAssignConditions = async (): Promise<{
  results: AssignConditionType[];
}> => {
  const response = await api.get<{
    results: AssignConditionType[];
  }>("", {
    baseURL: API_BASE_URL,
  });
  return response.data;
};

export const updateAssignConditions = async (
  userId: string,
  assignConditions: AssignConditionType[],
): Promise<ManageUserAssignConditionResponse> => {
  const response = await api.put<ManageUserAssignConditionResponse>(
    `/${userId}`,
    {
      assign_condition_ids: assignConditions.map(
        (assignCondition) => assignCondition.id,
      ),
    },
    {
      baseURL: API_BASE_URL,
    },
  );
  return response.data;
};

export const fetchManageUserAssignConditions = async (
  userId: string,
): Promise<ManageUserAssignConditionResponse> => {
  const response = await api.get<ManageUserAssignConditionResponse>(
    `/${userId}/manage_user_assign_conditions`,
    {
      baseURL: API_BASE_URL,
    },
  );
  return response.data;
};

export const fetchAssignConditionsUsersList = async (): Promise<{
  results: ManageUserAssignConditionResponse[];
}> => {
  const response = await api.get<{
    results: ManageUserAssignConditionResponse[];
  }>(`/user_list`, {
    baseURL: API_BASE_URL,
  });
  return response.data;
};
